"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// MIT © 2017 azu
var map_like_1 = require("map-like");
/**
 * TODO: make strong type
 */
var StoreStateMap = /** @class */ (function (_super) {
    __extends(StoreStateMap, _super);
    function StoreStateMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StoreStateMap.prototype, "stores", {
        get: function () {
            return this.keys();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoreStateMap.prototype, "stateNames", {
        get: function () {
            return this.values();
        },
        enumerable: true,
        configurable: true
    });
    return StoreStateMap;
}(map_like_1.MapLike));
exports.StoreStateMap = StoreStateMap;
/**
 * Create StateStoreMap from mapping object
 *
 * ## Mapping object
 *
 * - key: state name
 * - value: store instance
 *
 * ```js
 * var mapping = {
 *  "stateName": store
 * }
 * ```
 */
function createStoreStateMap(mappingObject) {
    var map = new StoreStateMap();
    // Suppress: Element implicitly has an 'any' type because type 'StoreMap<T>' has no index signature.
    var keys = Object.keys(mappingObject);
    for (var i = 0; i < keys.length; i++) {
        var stateName = keys[i];
        var store = mappingObject[stateName];
        map.set(store, String(stateName));
    }
    return map;
}
exports.createStoreStateMap = createStoreStateMap;
//# sourceMappingURL=StoreStateMap.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UILayer/StoreStateMap.js
// module id = 468
// module chunks = 0